import { anatomy } from '@shared/tokens/anatomy.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    fontFamily: fonts.din2014Regular,
    height: anatomy['size-56'],
    marginTop: anatomy['size-4'],
  },
});
